import { z } from 'zod';

import { oneOrMany } from '../../utils.js';
import { BaseItemSchema } from '../common.js';

export enum AssignmentGroupStatus {
  Active = 'Active',
  SoftDeleted = 'SoftDeleted',
}

export const BaseAssignmentGroupSchema = z.object({
  name: z.string().min(1),
  description: z.string(),
  organizationId: z.string().uuid(),
  state: z.nativeEnum(AssignmentGroupStatus),
});
export type BaseAssignmentGroup = z.infer<typeof BaseAssignmentGroupSchema>;

export const AssignmentGroupSchema = BaseAssignmentGroupSchema.extend({
  ...BaseItemSchema.shape,
});
export type AssignmentGroup = z.infer<typeof AssignmentGroupSchema>;

export type AssignmentGroupBasic = Pick<AssignmentGroup, 'id' | 'name'>;

export const AssignmentGroupQueryParamsSchema = z.object({
  id: oneOrMany(z.string().uuid()).optional(),
  organizationId: oneOrMany(z.string().uuid()).optional(),
  q: z.string().optional(),
  name: z.string().optional(),
  state: z.nativeEnum(AssignmentGroupStatus).optional(),
  limit: z.coerce.number().positive().optional(),
  offset: z.coerce.number().min(0).optional(),
});
export type AssignmentGroupQueryParams = z.infer<typeof AssignmentGroupQueryParamsSchema>;
